import { CREATE_BANNER, UPDATE_BANNER, DEACTIVATE_BANNER, GET_BANNERS, GET_ERRORS } from '../../../../actions/types';
import { getBanners, createBanner, updateBanner, deactivateBanner } from '../../../../actions/BannerActions';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { getAllProducts } from '../../../../actions/ProductActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import BootstrapTable from 'react-bootstrap-table-next';
import LoadingOverlay from 'react-loading-overlay';
import 'react-widgets/dist/css/react-widgets.css';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import MuiAlert from '@material-ui/lab/Alert';
import Dialog from '@material-ui/core/Dialog';
import docs from '../../../../config/docs';
import { Info } from '@material-ui/icons';
import React, { Component } from 'react';
import { IconButton } from 'material-ui';
import BannerModal from './BannerModal';
import { connect } from 'react-redux';
import './Banner.scss';

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const URL = docs.docsBanners;

class Banners extends Component {

	state = {
		skip:                 1,
		errorMessage:         null,
		productName:          'AMPICILINA',
		productSku:           null,
		modalIsVisible:       false,
		banners:              [],
		activeLoader:         true,
		showDeactivateDialog: false,
		selectedId:           0,
		showSnackBar:         false,
		textSnackBar:         '',
		severitySnackBar:     'success',
		page:                 1,
		limit:                15,
		totalPages:           0,
		modalBannerData:      {
			order: null,
			type:  null,
			_id:   null,
			id:    null,
			skues: [],
			url:   null
		}
	}

	constructor(props) {
		super(props);
		this.handleClose                 = this.handleClose.bind(this);
		this.handleCloseDeactivateDialog = this.handleCloseDeactivateDialog.bind(this);
		this.onDeactivate                = this.onDeactivate.bind(this);
	}


	componentDidMount() {
		this.props.getBanners(this.state.page, this.state.limit);
		this.props.getAllProducts();
	}

	componentDidUpdate(prevProps) {
		if (this.state.banners !== this.props.banners) {
			this.setState({
				banners:      this.props.banners,
				totalPages:   this.props.totalPages,
				activeLoader: false
			})
		} else if (this.props.actionType === DEACTIVATE_BANNER && prevProps.actionType !== DEACTIVATE_BANNER) {
			this.props.getBanners(this.state.page, this.state.limit);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Banner desactivado exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === UPDATE_BANNER && prevProps.actionType !== UPDATE_BANNER) {
			this.props.getBanners(this.state.page, this.state.limit);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Banner actualizado exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === CREATE_BANNER && prevProps.actionType !== CREATE_BANNER) {
			this.props.getBanners(this.state.page, this.state.limit);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Banner creado exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     this.props.error,
				severitySnackBar: 'error',
			});
		}
	}

	///---------------------------------------EVENTS-------------------------------------

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false
		})
	};

	handleCloseDeactivateDialog = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showDeactivateDialog: false
		})
	};

	onChangeMatchData(e) {
		let productName = e.target.value;
		this.setState({ productName })
	}

	onChangeSku(e) {
		let productSku = e.target.value;
		this.setState({ productSku })
	}

	toogleSearch() { }

	onCloseModal() {
		this.setState({
			activeLoader: true,
			modalIsVisible: false,
			modalBannerData: null
		})
		this.render()
	}

	onPressCancel() {
		this.setState({
			modalIsVisible: false,
			modalBannerData: null
		})
		this.render()
	}

	redirectTo() {
		const newWindow = window.open(URL, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}


	onUpdate(_id, skues, url, order, type) {
		this.props.updateBanner(_id, skues, url, order, type);
	}

	postMultipleSkuesProduct(_id, skues, url, order, type) {
		this.props.createBanner(_id, skues, url, order, type);
	}

	createBanner() {
		this.setState({
			modalIsVisible: true,
			modalBannerData: {
				order: null,
				type: null,
				_id: null,
				id: null,
				skues: [],
				url: null
			}
		})
	}

	onDelete(value) {
		this.setState({
			showDeactivateDialog: true,
			selectedId: value,
		})
	}

	onDeactivate() {
		this.setState({
			activeLoader: true,
			modalIsVisible: false,
			showDeactivateDialog: false
		});
		this.props.deactivateBanner(this.state.selectedId);
	}

	///---------------------------------------VIEW-------------------------------------

	render() {

		const columns = [
			{
				dataField: 'url',
				text: 'Imagen',
				formatter: (cell) => {
					return <img
						src={cell}
						width="30%"
						alt={"Imagen no existe en " + cell}
					/>
				}
			},

			{
				dataField: 'dataType',
				text: 'Tipo',
			},

			{
				dataField: 'order',
				text: 'Orden',
			},

			{
				dataField: 'skues',
				text: 'SKU',
				headerStyle: () => {
					return { width: "50%" };
				},
				formatter: (cell) => cell ? cell.join(" , ") : ""
			},
			{
				dataField: 'created_at',
				text: 'Fecha de creación',
				formatter: (cell) => cell ? new Date(cell).toLocaleDateString() : ""
			},
		];

		const rowEvents = {
			onClick: (e, row, rowIndex) => {
				this.setState({
					modalIsVisible: true,
					modalBannerData: row
				})
			}
		};

		return (
			<div className="main-content">
				<div className="malls-category-headers">
					BANNERS
					<IconButton size="small">
						<Info onClick={() => this.redirectTo()} />
					</IconButton>
				</div>
				<div className="auth-label"></div>
				<div className="auth-label"></div>
				<center>
					<div className="modal-activity-section">
						<button className="modal-buttonAdd" onClick={this.createBanner.bind(this)}>Agregar</button>
					</div>
					<div className="auth-error">{this.props.errors}</div>
					<div className="user-category-wrapper">
						{this.state.banners && this.state.banners.length > 0 &&
							<BootstrapTable keyField='id'
								key="8908290138209"
								striped
								hover
								condensed
								rowEvents={rowEvents}
								data={this.state.banners}
								headerWrapperClasses="title-table"
								rowClasses="custom-row-table"
								columns={columns}
							/>
						}
						{
							<div className="toolbar100 end">
								<button
									className={this.state.page !== 1 ? "modalButtonPager" : "modalButtonPager disabled"}
									onMouseDown={(e) => {
										e.preventDefault();
										this.setState({
											activeLoader: true,
											page: this.state.page - 1
										}, () => {
											this.props.getBanners(this.state.page, this.state.limit);
										});
									}}
									disabled={this.state.page === 1 ? true : false}
								>
									« Anterior
								</button>

								<button
									className={this.state.page < this.state.totalPages ? "modalButtonPager" : "modalButtonPager disabled"}
									onMouseDown={(e) => {
										e.preventDefault();
										this.setState({
											activeLoader: true,
											page: this.state.page + 1,
										}, () => {
											this.props.getBanners(this.state.page, this.state.limit);
										});
									}}
									disabled={this.state.page < this.state.totalPages ? false : true}
								>
									Siguiente »
								</button>
							</div>
						}

						{
							this.state.banners && this.props.products &&
							<BannerModal
								isVisible={this.state.modalIsVisible}
								modalBannerData={this.state.modalBannerData}
								products={this.props.products}
								onPressCancel={this.onPressCancel.bind(this)}
								onCloseModal={this.onCloseModal.bind(this)}
								postMultipleSkuesProduct={this.postMultipleSkuesProduct.bind(this)}
								onDelete={this.onDelete.bind(this)}
								onUpdate={this.onUpdate.bind(this)}
							/>
						}
						{
							<LoadingOverlay
								active={this.state.activeLoader}
								isVisible={this.state.activeLoader}
								spinner
								text='Esto puede tardar unos minutos'
								styles={{
									wrapper: {
										width: this.state.activeLoader ? '100%' : '0%',
										height: this.state.activeLoader ? '100%' : '0%',
										overflow: 'hidden',
									},
									overlay: (base) => ({
										...base,
										background: 'rgba(10, 10, 10, 0.7)'
									})
								}}>
							</LoadingOverlay>
						}
						{
							<Dialog
								open={this.state.showDeactivateDialog}
								onClose={this.handleCloseDeactivateDialog}
								aria-labelledby="alert-dialog-title"
								aria-describedby="alert-dialog-description"
							>
								<DialogTitle id="alert-dialog-title">{"Eliminar Banner"}</DialogTitle>
								<DialogContent>
									<DialogContentText id="alert-dialog-description">
										¿Seguro que deseas eliminar el banner?
									</DialogContentText>
								</DialogContent>
								<DialogActions>
									<Button onClick={this.handleCloseDeactivateDialog} color="secondary">
										Cancelar
									</Button>
									<Button onClick={this.onDeactivate} color="primary" autoFocus>
										Eliminar
									</Button>
								</DialogActions>
							</Dialog>
						}
						{
							<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
								<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
									{this.state.textSnackBar}
								</Alert>
							</Snackbar>
						}
					</div>
				</center>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	products:   state.product_reducer.allProducts,
	banners:    state.banner_reducer.banners,
	totalPages: state.banner_reducer.totalPages,
	error:      state.banner_reducer.error,
	success:    state.banner_reducer.success,
	actionType: state.banner_reducer.actionType
});

export default connect(
	mapStateToProps,
	{
		getBanners,
		getAllProducts,
		createBanner,
		updateBanner,
		deactivateBanner
	}
)(Banners);
